/* global Sys, Core, Resources, Utils */
Sys.ns("Core");

/**
 * The Postman controller.
 *
 * @class Core.PostmanController
 * @extends Core.Controller
 */
Core.PostmanController = {

    IS_READY: false,
    PLUGIN_TIMEOUT: 30000,

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PostmanController.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     * @listens request:postman.sendMessage
     * @listens notify:stateHandler.enteringSetupGameState
     */
    setupEvents: function() {
        var me = this;

        this.pluginURL = Resources.readData("pluginURL");

        // Temporary solution for supporting Sweden Integration until we start supporting mobile games in an iFrame
        this.enableSwedenPlugin = Resources.readData("queryData") ? Resources.readData("queryData").enableDefaultSwedenButtons : false;
        this.swedenButtonPluginHost = Resources.readData("queryData") ? Resources.readData("queryData").swedenButtonPluginHost : undefined;

        this.hiddenIframeForSweden = null;

        this.iframe = null;

        this.on({
            "request:postman.sendMessage": this.sendMessage,
            "notify:stateHandler.enteringSetupGameState": this.setupPlugin
        });

        window.addEventListener("message", function(e) {
            // this is done in order to test this code as postMessage
            // does not work in PhantomJS
            me.onMessage(e);
        });
    },

    /**
     * Handles message through the post message API.
     *
     * @private
     * @param {Object} evt Event data.
     * @returns {void}
     */
    onMessage: function(evt) {
        if (evt.data.moduleId) {
            this.fireEvent("notify:" + evt.data.moduleId + ".notification", evt.data);
        }
        else {
            this.handleIncomingMessage(evt.data);
        }
    },

    /**
     * If the game supports standalone mode (supports operator plugin) then an iframe is added with the plugin,
     * else if not, modules ready event will be fired and the game can continue the state change.
     *
     * @private
     * @returns {void}
     */
    setupPlugin: function() {
        var me = this,
            viewport;

        if (this.pluginURL) {
            // Temporary solution for supporting Sweden Integration until we start supporting mobile games in an iFrame
            if (this.enableSwedenPlugin) {
                this.loadPluginForSwedenIntegration();
            }
            this.iframe = document.createElement("iframe");
            this.iframe.setAttribute("id", "netEntExtendPlugin");
            this.iframe.setAttribute("sandbox", "allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin allow-forms allow-pointer-lock");
            this.iframe.setAttribute("frameborder", 0);
            this.iframe.setAttribute("width", "100%");
            this.iframe.setAttribute("height", 0);
            this.iframe.src = this.pluginURL;
            viewport = document.getElementById("viewport");
            viewport.insertBefore(this.iframe, viewport.firstChild);
            // timeout for plugin load
            this.timeout = setTimeout(function() {
                me.fireEvent("request:loaderErrorHandler.handlePluginTimeoutError");
            }, this.PLUGIN_TIMEOUT);
        }
        else {
            this.fireEvent("notify:postman.ready");
            this.IS_READY = true;
        }
    },

    /**
     * Check for and handle the plugin ready call, with optional plugin menu parameters.
     *
     * @param {string[]} argArray Array of arguments.
     * @returns {void}
     */
    handlePluginReadyCall: function(argArray) {
        var pluginMenuButtonURL = argArray[3],
            pluginMenuHeight = argArray[4],
            transparency = argArray[5];

        if (argArray[0] === "call" && argArray[2] === "pluginReady") {
            clearTimeout(this.timeout);

            this.IS_READY = true;
            this.fireEvent("notify:postman.ready");
            if (Sys.isDefined(pluginMenuButtonURL) && Sys.isDefined(pluginMenuHeight)) {
                this.fireEvent("request:pluginMenu.init", pluginMenuButtonURL, pluginMenuHeight, transparency);
            }
            this.sendMessage(["success", argArray[1]]);
        }
    },

    /**
     * Handle the incoming message from the post message API.
     * If the game supports standalone mode (plugin), then the first message
     * should be `pluginReady` sent by the plugin loader.
     *
     * @param {string[]} argArray Array of arguments.
     * @returns {void}
     */
    handleIncomingMessage: function(argArray) {
        if (this.pluginURL && !this.IS_READY) {
            this.handlePluginReadyCall(argArray);
        }
        else {
            this.fireEvent.apply(this, ["request:NetEntExtend.newMessage"].concat(argArray));
        }
    },

    /**
     * Sends a message through the post message API to top and inside of plugin iframe as well.
     *
     * @param {*} message Message.
     * @returns {void}
     */
    sendMessage: function(message) {
        if (Utils.Platform.inIframe()) {
            window.parent.postMessage(message, "*");
        }
        if (this.iframe && this.pluginURL) {
            this.iframe.contentWindow.postMessage(message, "*");
            if (this.hiddenIframeForSweden) {
                this.hiddenIframeForSweden.contentWindow.postMessage(message, "*");
            }
        }
    },

    /* Temporary solution for Sweden Market integration */
    loadPluginForSwedenIntegration: function() {
        var cssReference = document.createElement("link"),
            gameId = Resources.readData("queryData").gameId;

        this.hiddenIframeForSweden = document.createElement("iframe");
        this.hiddenIframeForSweden.setAttribute("frameborder", 0);
        this.hiddenIframeForSweden.setAttribute("style", "width: 100%;height: 0px;z-index: -1;position: absolute;");
        this.hiddenIframeForSweden.src = (this.swedenButtonPluginHost ? this.swedenButtonPluginHost : "https://static-shared.casinomodule.com") + "/sweden-plugin/sweden_buttons.html?gameid=" + gameId;
        this.cssPath = (this.swedenButtonPluginHost ? this.swedenButtonPluginHost : "https://static-shared.casinomodule.com") + "/sweden-plugin/origin.css";
        document.body.insertBefore(this.hiddenIframeForSweden, document.body.firstChild);

        cssReference.href = this.cssPath;
        cssReference.type = "text/css";
        cssReference.rel = "stylesheet";

        document.body.classList.add("sweden-regulation");
        document.body.classList.add(gameId);

        document.getElementsByTagName("head")[0].appendChild(cssReference);
    }
};

Core.PostmanController = Sys.extend(Core.Controller, Core.PostmanController, "Core.PostmanController");
